import { DrawerContext } from '@notino/react-styleguide';

import { MultistepModal } from '@components/MultistepModal';
import { isDesktop } from '@utils/helpers';

import { DRAWER_SHADEFINDER_CONFIG } from '../config';

type TransitionProps = {
  currentStep: number;
  showTitle?: boolean;
  showProgress?: boolean;
  name: string;
};

export type IUseShadefinderTransitions = {
  back: () => void;
  close: () => void;
  transition: (content: JSX.Element, props: TransitionProps) => void;
  animateProgress: (props: TransitionProps) => void;
};

export const useShadefinderTransitions = (): IUseShadefinderTransitions => {
  const {
    transition: modalTransition,
    closeModal,
    back: backModal,
    animateProps: animateModal,
  } = MultistepModal.useMultistepModal();
  const {
    transition: drawerTransition,
    closeDrawer,
    back: backDrawer,
    animateProps: animateDrawer,
  } = DrawerContext.useDrawerContext();

  const transition = (
    content: JSX.Element,
    { currentStep, showTitle = true, showProgress = true, name }
  ) => {
    if (isDesktop()) {
      modalTransition(content, {
        currentStep,
        title: showTitle ? undefined : () => '', // when undefined, MultiStepModal shows basic current/total steps
        showProgress,
        name,
      });
    } else {
      drawerTransition(content, {
        currentStep,
        title: showTitle ? DRAWER_SHADEFINDER_CONFIG.title : undefined,
        showProgress,
        name,
      });
    }
  };

  const close = () => {
    if (isDesktop()) {
      closeModal();
    } else {
      closeDrawer();
    }
  };

  const back = () => {
    if (isDesktop()) {
      backModal();
    } else {
      backDrawer();
    }
  };

  const animateProgress = ({
    currentStep,
    showProgress = true,
    showTitle = true,
  }) => {
    if (isDesktop()) {
      animateModal({
        currentStep,
        showProgress,
        title: showTitle ? undefined : () => '', // when undefined, MultiStepModal shows basic current/total steps
      });
    } else {
      animateDrawer({
        currentStep,
        showProgress,
        showBack: true,
        title: showTitle ? DRAWER_SHADEFINDER_CONFIG.title : undefined,
      });
    }
  };

  return {
    transition,
    animateProgress,
    close,
    back,
  };
};
